var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading_component"},[_c('div',{staticClass:"skeleton"},_vm._l((1),function(item,i){return _c('skeleton',{key:i})}),1),_c('div',{staticClass:"loading"},[_c('loading')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }